// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"style__headerWrapper__7Vtdr","logo":"style__logo__51jx3"};